const menuData = [
  {
    "title": "More information",
    "links": [
      { "label": "Contact us", "url": "/contact" },
      { "label": "About", "url": "/about" },
      { "label": "Find a rental location", "url": "/" }
    ]
  },
  {
    "title": "Business center",
    "links": [
      { "label": "Business solutions", "url": "/" },
      { "label": "Tour operators", "url": "/" },
      { "label": "Travel agents", "url": "/" }
    ]
  },
  {
    "title": "Europcar Mobility Group",
    "links": [
      { "label": "Careers", "url": "/" },
      // { "label": "Goldcar", "url": "/" },
      { "label": "Europcar On Demand", "url": "/" },
      { "label": "Europcar", "url": "/" }
    ]
  },
  {
    "title": "Legal Information",
    "links": [
      { "label": "Privacy Policy", "url": "/privacy-policy" },
      { "label": "Terms And Conditions", "url": "/terms-and-conditions" },
      { "label": "Cancellation Policy", "url": "/cancellation-policy" },
      { "label": "Refund Policy", "url": "/refund-policy" },
      { "label": "Car Upgrade Policy", "url": "/car-upgrade-policy" },

    ]
  }
]

export default menuData;

